export default __webpack_public_path__ + "static/media/DSC05902.5f629690.jpg";